module.exports = __webpack_public_path__ + "static/media/seedling.f74e414d.svg";